import { render, staticRenderFns } from "./ManageCompaniesRoles.vue?vue&type=template&id=7016c79e&scoped=true&"
import script from "./ManageCompaniesRoles.vue?vue&type=script&lang=js&"
export * from "./ManageCompaniesRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7016c79e",
  null
  
)

export default component.exports